<template>
  <div>
    <div class="d-flex justify-content-between mb-1 font-weight-bold align-items-center">
      <div>{{ t.search_header }}</div>
      <button @click="resetFilter" class="btn btn-dark-link text-sm text-underline">
        {{ t.delete }}
      </button>
    </div>
    <FormInput v-model="filterValue" :placeholder="t.search_placeholder" type="text" name="search">
      <button class="btn btn-secondary-subtle">
        <SearchIcon class="svg-16 svg-fill-current" />
      </button>
    </FormInput>
  </div>
</template>

<script>
import FormInput from "./FormInput";
import SearchIcon from "../../icons/atalanda/search.svg";
import debounce from "lodash/debounce";
import { mapActions } from "vuex";

export default {
  name: "BrandSearch",
  components: {
    SearchIcon,
    FormInput,
  },
  props: {
    t: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filterValue: "",
    };
  },
  watch: {
    filterValue: debounce(function(val) {
      this.setBrandFilterValue(val);
    }, 150),
  },
  methods: {
    ...mapActions({
      setBrandFilterValue: "brand/setBrandFilterValue",
    }),
    resetFilter() {
      this.filterValue = "";
    },
  },
};
</script>
